import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { connect } from 'react-redux';
import { modalActions, yodleeConsentActions } from '../../../redux/root-action';
import ReactModalHeader from '../../Modal/ReactModalHeader';
import { modals, responseStatus } from '../../../utils/constants';

interface Props {
  fetchYodleeConsent: Function;
  yodleeConsent?: any;
  yodleeConsentIndicator?: boolean;
  hideModal: Function;
  showModal: Function;
}

const rotate = keyframes`
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;

const Loader = styled.div`
  position: relative;
  text-indent: -9999em;
  border: 2px solid #d6d6d5;
  border-left-color: ${tokens.ColorBrandBrightBlue};
  border-width: 8px;
  margin: 64px auto 96px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 2.5s infinite linear;
  animation: ${rotate} 2.5s infinite linear;
  border-radius: 50%;
  width: 160px;
  height: 160px;
  @media (max-width: 768px) {
    width: 120px;
    height: 120px;
    border-width: 6px;
  }
`;

class YodleeRedirect extends Component<Props> {
  handleCloseIconClick = () => {
    const { hideModal } = this.props;
    hideModal(modals.YODLEE_REDIRECT);
  };

  componentDidMount() {
    const { fetchYodleeConsent } = this.props;
    fetchYodleeConsent();
  }

  componentDidUpdate(prevProps: any) {
    const { yodleeConsent, showModal } = this.props;
    const yodleeConsentIndicator = yodleeConsent.yodleeConsent && yodleeConsent.yodleeConsent[0]?.consentIndicator;

    if (
      prevProps.yodleeConsent.yodleeConsentLoaded !== yodleeConsent.yodleeConsentLoaded &&
      yodleeConsent.yodleeConsentLoaded === responseStatus.SUCCESS
    ) {
      if (yodleeConsentIndicator && yodleeConsentIndicator === true) {
        showModal(modals.YODLEE_IFRAME);
      } else {
        showModal(modals.YODLEE_THIRD_PARTY);
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <ReactModalHeader showClose={true} handleCloseIconClick={this.handleCloseIconClick} />
        <Loader />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ yodleeConsent }: any) => ({
  yodleeConsent,
});

export default connect(mapStateToProps, {
  showModal: modalActions.showModal,
  hideModal: modalActions.hideModal,
  fetchYodleeConsent: yodleeConsentActions.fetchYodleeConsent,
})(YodleeRedirect);
